export const LANGUAGE_KEY = 'language' as const
